// extracted by mini-css-extract-plugin
module.exports = {"header":"LayoutCommon_header__2mMWJ","footer":"LayoutCommon_footer__3No8m","sidebar":"LayoutCommon_sidebar__2bb8o","sidebar_list":"LayoutCommon_sidebar_list__1Fjv_"};